// extracted by mini-css-extract-plugin
export var dropdownContainer = "_l0-0";
export var leftAlign = "_l0-4";
export var listItem = "_l0-2";
export var listItemWrapper = "_l0-1";
export var operationText = "_l0-3";